import type { EnderRealmClient } from './client';

/** 读取后端环境配置（environment/server_name/region/custom_config） */
export function getEnvironmentIdentity(client: EnderRealmClient) {
  return client.GET('/v1/environment/');
}